import Backbone from 'backbone';
import messageTemplate from '../template/coupon-steps.pug';

export default class View extends Backbone.View {
  initialize({ steps }) {
    this.steps = steps;
  }

  render() {
    this.$el.html(messageTemplate({
      steps: this.steps,
    }));
    return this;
  }
}
